import * as React from 'react';
import {useRef, useState, useLayoutEffect} from "react";
import './AllForms.scss';
import '../SecondLevel.scss';
import {ArticleCard} from "../../../components/UI/ArticleCard"
import cutStrings from '../../../components/UI/CutText';

const AllForms = () => {
    const [pageText, setPageText] =useState({__html: ''})
    const [forms, setForms] = useState([])
    const pageWidth = useRef(null);
    const blockHeight = useRef('400');

    const [appState, setAppState] = useState({
        loading: false,
        repos: null,
    });

    useLayoutEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/getTextByTitleAsHtml`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({title: 'Описание', pageTitle: 'Анкеты'}),
        }).then((response) => {
            response.text().then(text => {
                const data = text && JSON.parse(text);
                setPageText({__html: data.textContent})
            });
            setAppState({ loading: false, repos: response});
        }).catch(function(error) {
            console.log(error)
        });
        fetch(`${process.env.REACT_APP_API_URL}/getActiveForms`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(""),
      }).then((response) => {
          response.text().then(text => {
              const data = text && JSON.parse(text)
              const changedData = data.map((element) => ({
                id: element.form.id,
                title: element.form.formTitle,
                logo: element.formLogo.logoContent,
                description: cutStrings(element.form.description),
                time: element.form.creationTime,
                url: element.form.formUrl
              }))
            setForms(changedData)
          });
          setAppState({ loading: false, repos: response});
      }).catch(function(error) {
        setForms([])
      })
    }, [setAppState])

    
    return (
        <div className='second-level' ref={pageWidth}>
            <div className='second-level__title'>
                Здесь вы можете видеть все наши анкеты
            </div>
            <div className='content-text__paragraf' dangerouslySetInnerHTML={pageText}/>
            <div className='all-forms__block' ref={blockHeight}>
                {forms && forms?.map((form, i) => (
                    <ArticleCard key={i}
                        cardId={i}
                        classes={'light-border'} 
                        src={form.logo} 
                        articleText={form.title}
                        articleDescription={form.description}
                        data={form.time.split('T', 1)} 
                        linkAlter={'/forms/'+form.id}
                        width={350+"px"}/>
                ))}
            </div>
        </div>
    )
}

export default AllForms;